// extracted by mini-css-extract-plugin
module.exports = {"pymtDtl":"debit_pymtDtl__1zQX1"};